import { render, staticRenderFns } from "./DeckView.vue?vue&type=template&id=6fb22b0d&"
import script from "./DeckView.ts?vue&type=script&lang=ts&"
export * from "./DeckView.ts?vue&type=script&lang=ts&"
import style0 from "./DeckView.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports